import { NgModule } from '@angular/core';
import { ClosedRequestsComponent } from './requests/closed-requests/closed-requests.component';
import { InvoiceRequestsComponent } from './requests/invoice-requests/invoice-requests.component';
import { OpenRequestsComponent } from './requests/open-requests/open-requests.component';
import { NotAssignedComponent } from './requests/not-assigned/not-assigned.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// components
import { HeaderComponent } from './layout/header/header.component';
import { RequestsComponent } from './requests/requests.component';
import { MenuComponent } from './layout/menu/menu.component';
import { AirlineSettingsComponent } from './settings/airline-settings/airline-settings.component';
import { CustomerSettingsComponent } from './settings/customer-settings/customer-settings.component';
import { DeletionDialogComponent } from './layout/deletion-dialog/deletion-dialog.component';

import { BrokerSettingsComponent } from './settings/broker-settings/broker-settings.component';
import { AssignDialogComponent } from './requests/assign-dialog/assign-dialog.component';

import { ERateSheetComponent } from './settings/airline-settings/e-rate-sheet/e-rate-sheet.component';
import { DialogStructureComponent } from './layout/dialog-structure/dialog-structure.component';
import { CustomerSettingsDialogComponent } from './settings/customer-settings/customer-settings-dialog/customer-settings-dialog.component';
import { AirlineSettingsDialogComponent } from './settings/airline-settings/airline-settings-dialog/airline-settings-dialog.component';
import { BrokerSettingsDialogComponent } from './settings/broker-settings/broker-settings-dialog/broker-settings-dialog.component';
import { GsaSettingsComponent } from './settings/gsa-settings/gsa-settings.component';
import { UserSettingsComponent } from './settings/user-settings/user-settings.component';
import { UserSettingsDialogComponent } from './settings/user-settings/user-settings-dialog/user-settings-dialog.component';



import { AuthModule } from './auth/auth.module';
import { GsaSettingsDialogComponent } from './settings/gsa-settings/gsa-settings-dialog/gsa-settings-dialog.component';
import { MainSettingsComponent } from './settings/main-settings/main-settings.component';
import { SanitizeHtmlPipe } from './auth/pipes/sanitizehtml.pipe';
import { MaterialModule } from './material.module';
import { PaginatorSpinnerComponent } from './layout/paginator-spinner/paginator-spinner.component';
import { AttachmentDndDirective } from './requests/request-details/attachment-dnd.directive';
import { RequestDetailsComponent } from './requests/request-details/request-details.component';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatChipsModule } from '@angular/material/chips';


@NgModule({ declarations: [AppComponent], bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AuthModule,
        ClipboardModule,
        AngularEditorModule,
        MaterialModule,
        MatChipsModule, HeaderComponent,
        RequestsComponent,
        CustomerSettingsComponent,
        DeletionDialogComponent,
        MenuComponent,
        AirlineSettingsComponent,
        BrokerSettingsComponent,
        RequestDetailsComponent,
        AssignDialogComponent,
        ERateSheetComponent,
        DialogStructureComponent,
        CustomerSettingsDialogComponent,
        AirlineSettingsDialogComponent,
        BrokerSettingsDialogComponent,
        GsaSettingsComponent,
        UserSettingsComponent,
        UserSettingsDialogComponent,
        GsaSettingsDialogComponent,
        MainSettingsComponent,
        SanitizeHtmlPipe,
        RequestsComponent,
        NotAssignedComponent,
        OpenRequestsComponent,
        InvoiceRequestsComponent,
        ClosedRequestsComponent,
        PaginatorSpinnerComponent,
        AttachmentDndDirective], providers: [AuthModule, SanitizeHtmlPipe, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {}
